export const tr = {
    'default-tab-name': 'Standart',
    'idea-tab-name': 'Sayfadaki görseller',
    'recently-used-tab-name': 'Daha önce kullanılanlar'
};
